import type { Category } from "@/content/templates/template.types";
import { useLocalizedHref } from "@/libraries/web-framework";

export interface SEOTemplateLinkProps {
    category: Category;
}

export const SEOCategoryLink = ({ category }: SEOTemplateLinkProps) => {
    const categoryHref = useLocalizedHref(
        category.urlSlug === "recommended"
            ? "/software/confluence/templates"
            : `/software/confluence/templates/categories/${category.urlSlug}`
    );

    return <a href={categoryHref}>{category.name}</a>;
};
